export default __webpack_public_path__ + "static/media/copy.6de915a0.svg";